(() => {
  'use strict';

  const CARD_SELECTOR = ':is(.cc-collection-products, .cc-product-recommendations) product-card.card--product';
  const TITLE_LINK_SELECTOR = '.card__title .card-link';
  const CTA_CLASS = 'pw-card-cta';
  const ENERGY_ICON_MAP = Object.freeze({
    A: {
      src: 'https://cdn.shopify.com/s/files/1/0766/4051/8479/files/A.svg?v=1699963582',
      width: 54,
      height: 28
    },
    B: {
      src: 'https://cdn.shopify.com/s/files/1/0766/4051/8479/files/B.svg?v=1699963582',
      width: 54,
      height: 28
    },
    C: {
      src: 'https://cdn.shopify.com/s/files/1/0766/4051/8479/files/C.svg?v=1699963582',
      width: 54,
      height: 28
    },
    D: {
      src: 'https://cdn.shopify.com/s/files/1/0766/4051/8479/files/D.svg?v=1699963582',
      width: 54,
      height: 28
    },
    E: {
      src: 'https://cdn.shopify.com/s/files/1/0766/4051/8479/files/E.svg?v=1699963582',
      width: 54,
      height: 28
    },
    F: {
      src: 'https://cdn.shopify.com/s/files/1/0766/4051/8479/files/F.svg?v=1699963582',
      width: 54,
      height: 28
    },
    G: {
      src: 'https://cdn.shopify.com/s/files/1/0766/4051/8479/files/G.svg?v=1699963582',
      width: 54,
      height: 28
    },
    'A+': {
      src: 'https://cdn.shopify.com/s/files/1/0766/4051/8479/files/a-plus.webp?v=1726130082',
      width: 240,
      height: 97
    },
    'A++': {
      src: 'https://cdn.shopify.com/s/files/1/0766/4051/8479/files/aplusplus.webp?v=1726130101',
      width: 240,
      height: 97
    },
    'A+++': {
      src: 'https://cdn.shopify.com/s/files/1/0766/4051/8479/files/aplusplusplus.webp?v=1726130119',
      width: 240,
      height: 97
    }
  });

  function normaliseEnergyClass(value) {
    const compact = String(value ?? '')
      .trim()
      .toUpperCase()
      .replace(/ENERGIEKLASSE|ENERGIELABEL/g, '')
      .replace(/[:\s]/g, '');

    return compact.match(/A\+{1,3}|^[A-G]$/)?.[0] ?? '';
  }

  function enhanceEnergyLabel(card) {
    const rows = card.querySelectorAll('.card__info-inner > ul > li.lines');
    const row = Array.from(rows).find((item) =>
      /^\s*energielabel\s*:/i.test(item.textContent ?? '')
    );

    if (!row || row.querySelector('.pw-energy-label-icon')) return;

    const energyClass = normaliseEnergyClass(row.textContent);
    const icon = ENERGY_ICON_MAP[energyClass];
    if (!icon) return;

    const image = document.createElement('img');
    image.className = 'pw-energy-label-icon pw-energy-label-icon--card';
    image.src = icon.src;
    image.alt = `Energielabel ${energyClass}`;
    image.width = icon.width;
    image.height = icon.height;
    image.loading = 'lazy';

    row.classList.add('pw-card-energy-label');
    row.replaceChildren(image);
  }

  function enhanceCta(card) {
    if (card.querySelector(`.${CTA_CLASS}`)) return;

    const titleLink = card.querySelector(TITLE_LINK_SELECTOR);
    const title = titleLink?.textContent?.trim();

    if (!titleLink || !titleLink.href) return;

    const cta = document.createElement('a');
    cta.className = `${CTA_CLASS} js-prod-link`;
    cta.href = titleLink.href;
    cta.setAttribute('aria-label', title ? `Bekijk ${title}` : 'Bekijk product');

    const label = document.createElement('span');
    label.textContent = 'Bekijk product';

    const arrow = document.createElement('span');
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = '→';

    cta.append(label, arrow);
    titleLink.closest('.card__title')?.insertAdjacentElement('afterend', cta);
  }

  function enhanceCard(card) {
    if (!(card instanceof Element) || !card.matches(CARD_SELECTOR)) return;
    enhanceEnergyLabel(card);
    enhanceCta(card);
  }

  function enhanceWithin(scope) {
    if (!(scope instanceof Element || scope instanceof Document)) return;

    if (scope instanceof Element && scope.matches(CARD_SELECTOR)) {
      enhanceCard(scope);
    }

    scope.querySelectorAll?.(CARD_SELECTOR).forEach(enhanceCard);
  }

  function init() {
    enhanceWithin(document);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node instanceof Element) enhanceWithin(node);
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
